import React from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { DialogWrapper } from '../DialogWrapper';
import { useEscKey } from '../../../hooks/useEscKey';

interface UpdateSuccessDialogProps {
  open: boolean;
  onClose: () => void;
  selectedTicket: any;
  onView: () => void;
}

export const UpdateSuccessDialog: React.FC<UpdateSuccessDialogProps> = ({
  open,
  onClose,
  selectedTicket,
  onView
}) => {
  useEscKey(open, onClose);

  const handleView = () => {
    onView();
    onClose();
  };

  return (
    <DialogWrapper 
      open={open} 
      onClose={onClose}
      maxWidth="sm" 
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'success.main' }}>
          <CheckCircleIcon />
          Güncelleme Başarılı
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography>
          Talep başarıyla güncellendi.
        </Typography>
        {selectedTicket && (
          <Typography sx={{ mt: 1, fontWeight: 'bold' }}>
            Talep No: #{selectedTicket.id}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Kapat
        </Button>
        <Button onClick={handleView} variant="contained">
          Talebi Görüntüle
        </Button>
      </DialogActions>
    </DialogWrapper>
  );
};